// Digital (Touch ID) pela API nativa do navegador. Navegador antigo sem parse*FromJSON cai em passkeySupported() = false.
const PublicKey = () => window.PublicKeyCredential as any;

export const passkeySupported = (): boolean => !!PublicKey()?.parseRequestOptionsFromJSON;

export const createPasskey = async (options: unknown) => {
  const credential: any = await navigator.credentials.create({ publicKey: PublicKey().parseCreationOptionsFromJSON(options) });
  return credential.toJSON();
};

export const getPasskey = async (options: unknown) => {
  const credential: any = await navigator.credentials.get({ publicKey: PublicKey().parseRequestOptionsFromJSON(options) });
  return credential.toJSON();
};
